import { render, staticRenderFns } from "./formFileConfirmNew.vue?vue&type=template&id=2bc9446f&scoped=true&"
import script from "./formFileConfirmNew.vue?vue&type=script&lang=js&"
export * from "./formFileConfirmNew.vue?vue&type=script&lang=js&"
import style0 from "./formFileConfirmNew.vue?vue&type=style&index=0&id=2bc9446f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9446f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc9446f')) {
      api.createRecord('2bc9446f', component.options)
    } else {
      api.reload('2bc9446f', component.options)
    }
    module.hot.accept("./formFileConfirmNew.vue?vue&type=template&id=2bc9446f&scoped=true&", function () {
      api.rerender('2bc9446f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/formFileConfirmNew.vue"
export default component.exports